const pointerType = 'activeModes'
import type {Pointer} from '@wix/document-services-types'
import {pointerUtils} from '@wix/document-manager-core'

const {getPointer, getInnerPointer} = pointerUtils

const createPointersMethods = () => {
    const getPageActiveModes = (pageId: string) => getPointer('activeModes', pointerType, {innerPath: [pageId]})
    const getAllActiveModes = () => getPointer('activeModes', pointerType)

    const getModes = (pointer: Pointer) => getInnerPointer(pointer, ['modes'])
    const getModesDefinitions = (pointer: Pointer) => getInnerPointer(pointer, ['modes', 'definitions'])
    const getModesOverrides = (pointer: Pointer) => getInnerPointer(pointer, ['modes', 'overrides'])

    return {
        activeModes: {
            getPageActiveModes,
            getAllActiveModes
        },
        general: {
            getActiveModes: getAllActiveModes
        },
        componentStructure: {
            getModes,
            getModesDefinitions,
            getModesOverrides
        }
    }
}

export {createPointersMethods}
